export enum RefundOrderTypeEnum {
  FULL_REFUND = 'FULL_REFUND',

  PARTIAL_REFUND = 'PARTIAL_REFUND',
}
